/**
 * Default values if not provided.
 */
export const NUMBER_SPIN_BUTTON_DEFAULTS = {
  SMALL_STEP: 1, // Step size for arrow up/down keys
  BIG_STEP: 10, // Step size for page up/down keys
  VALUE: 0,
  MIN_VALUE: Number.MIN_SAFE_INTEGER,
  MAX_VALUE: Number.MAX_SAFE_INTEGER,
  PADDING_CHARS: '0',
} as const;
